import type { User } from '../firebase/auth';

/**
 * Whether a resolved Firebase user is a throwaway GUEST — the account carrying
 * the `isGuest` custom claim that guest checkout mints via `createGuestAccount`.
 *
 * Firebase-free at the import level (`User` is a type-only import + a method
 * call on the passed user), so callers that keep the SDK off their first-load
 * bundle can use it. Reads the cached claims (no forced token refresh).
 */
export async function isGuestUser(user: User): Promise<boolean> {
  const tokenResult = await user.getIdTokenResult();
  return tokenResult.claims.isGuest === true;
}
